import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { usePortalAuth } from "../../lib/portal-auth-context";
import {
  DataTable,
  PageHeader,
  formatMXN,
  useFetchList,
} from "./portal-ui";
import { MagnifyingGlass } from "@phosphor-icons/react";

export default function PortalCatalog() {
  const { api } = usePortalAuth();
  const { items, loading } = useFetchList(api, "/catalog");
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("");

  const categories = useMemo(
    () => Array.from(new Set(items.map((i) => i.category).filter(Boolean))),
    [items]
  );

  const filtered = useMemo(() => {
    const qq = q.trim().toLowerCase();
    return items.filter((i) => {
      if (cat && i.category !== cat) return false;
      if (!qq) return true;
      return (
        (i.name || "").toLowerCase().includes(qq) ||
        (i.sku || "").toLowerCase().includes(qq)
      );
    });
  }, [items, q, cat]);

  return (
    <div data-testid="portal-catalog-page">
      <PageHeader
        eyebrow="Catálogo"
        title="Productos con tu precio"
        subtitle="Precios y disponibilidad negociados para tu cuenta."
      />

      <div className="flex flex-col md:flex-row gap-3 mb-5">
        <div className="relative flex-1">
          <MagnifyingGlass
            size={16}
            className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
          />
          <input
            type="text"
            data-testid="portal-catalog-search"
            placeholder="Buscar por nombre o SKU…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            className="icor-input !pl-9"
          />
        </div>
        <select
          data-testid="portal-catalog-category"
          value={cat}
          onChange={(e) => setCat(e.target.value)}
          className="icor-input md:max-w-xs"
        >
          <option value="">Todas las categorías</option>
          {categories.map((c) => (
            <option key={c} value={c}>
              {c}
            </option>
          ))}
        </select>
      </div>

      <DataTable
        testId="portal-catalog-table"
        loading={loading}
        rows={filtered}
        emptyMsg="Sin coincidencias en el catálogo."
        columns={[
          { key: "sku", label: "SKU", render: (r) => r.sku || "—" },
          { key: "name", label: "Producto", render: (r) => r.name || "—" },
          { key: "category", label: "Categoría", render: (r) => r.category || "—" },
          { key: "warehouse", label: "Almacén", render: (r) => r.warehouse || "—" },
          {
            key: "available",
            label: "Disponibilidad",
            render: (r) =>
              r.available ? (
                <span className="text-emerald-700 font-semibold">En stock</span>
              ) : (
                <span className="text-amber-700 font-semibold">Por pedido</span>
              ),
          },
          {
            key: "unit_price",
            label: "Precio unitario",
            render: (r) => formatMXN(r.unit_price),
          },
          {
            key: "actions",
            label: "",
            render: (r) => (
              <Link
                to="/portal/new-quote"
                state={{ prefillSku: r.sku, prefillName: r.name }}
                className="text-[var(--icor-blue)] text-xs uppercase tracking-[0.18em] font-semibold hover:underline"
                data-testid={`portal-catalog-quote-${r.sku}`}
              >
                Cotizar →
              </Link>
            ),
          },
        ]}
      />
    </div>
  );
}
